;(function () {
  const productab = () => {
    $('.tabs').each(function () {
      const $section = $(this);
      const id = $section.attr('id');
      const buttons = $section.find('.tab-button');
      const contents = $section.find('.tab-content');
      const swipers = $section.find('.swiper');

      // ---- Tab 切换 ----
      buttons.on('click', function () {
        const index = $(this).attr('data-tab-index');
        buttons.removeClass('active');
        contents.removeClass('active');
        $(this).addClass('active');
        $section.find(`.tab-content[data-tab-index="${index}"]`).addClass('active');
      });

      // ---- Swiper 初始化 ----
      if (swipers.length > 0) {
        swipers.each(function () {
          const $swiper = $(this);
          const $pagination = $swiper.find('.pagination');
          const $prev = $swiper.find('.prev');
          const $next = $swiper.find('.next');

          // ---- 初始化 Swiper ----
          new Swiper(this, {
            slidesPerView: 1,
            spaceBetween: 10,
            breakpoints: {
              768: { slidesPerView: 2, spaceBetween: 20 },
              1200: { slidesPerView: 3, spaceBetween: 20 },
              1300: { slidesPerView: 3.4, spaceBetween: 20 },
            },
            pagination: { el: $pagination[0], clickable: true },
            navigation: { nextEl: $next[0], prevEl: $prev[0] },
          });

          const slides = $swiper.find('.swiper-slide');
          slides.each(function () {
            const randomID = Math.floor(Math.random() * 10000000000); // 生成10位随机数
            const $button = $(this).find('.quick-product__btn');
            const $modal = $(this).find('[id^="QuickShopModal-"]');

            if ($button.length && $modal.length) {
              // 更新 class 与 id
              const newClass = `js-modal-open--quickmodal-${randomID}`;
              const newID = `QuickShopModal-${randomID}`;

              // 移除旧 class (只移除以 js-modal-open-quick-modal- 开头的)
              $button.removeClass(function (index, className) {
                return (className.match(/js-modal-open--quickmodal-\S+/g) || []).join(' ');
              });

              // 添加新的 class 和更新 modal id
              $button.addClass(newClass);
              $modal.attr('id', newID);

              $swiper.append($modal)

              new theme.Modals(`QuickShopModal-${randomID}`, `-quickmodal-${randomID}`, { solid: true });

            }
          });
        });
      }
    });
  };

  // ---- DOM Ready ----
  document.addEventListener('DOMContentLoaded', function () {
    productab();
    document.addEventListener('shopify:section:load', function () {
      productab();
    });
  });
})();
